import styled from 'styled-components'

// styles
import { Row } from '../index.styles';

const WrapItem = styled(Row)`
    min-height: 54px;
    background: #FFFFFF;

    .bold, .normal {
        font-family: "Open Sans";
        font-style: normal;
        letter-spacing: -0.01em;
        color: #313131;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .bold {
        font-weight: 600;
        font-size: 13px;
        line-height: 18px;
    }
    .normal-text{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: normal;
        font-size: 13px;
        line-height: 18px;
    }
    .normal {
        display: flex;
        align-items: center;
        gap: 8px;


        .logo-merchant{
            width: 30px;
            height: 30px;
            border-radius: 50%;
        }
    }
    svg{
        display: flex;
        align-items: center;
    }
`

const WrapStoreItem = styled(WrapItem)`

`;

export {
    WrapStoreItem,
    WrapItem,
}